export default __webpack_public_path__ + "static/media/money.72da7c48.svg";